import { render, staticRenderFns } from "./DomainPageTemplate.vue?vue&type=template&id=674ef49f&scoped=true&"
import script from "./DomainPageTemplate.vue?vue&type=script&lang=js&"
export * from "./DomainPageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DomainPageTemplate.vue?vue&type=style&index=0&id=674ef49f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674ef49f",
  null
  
)

export default component.exports